import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-listing-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "crm-listing-edit-columns-modal" */'./EditColumnsModal').then(mod => mod.default).catch(AsyncComponentErrorHandler('crm-listing-edit-columns-modal'))
});